import UtilFile from "@/framework/Utils/UtilFile";
import Http from "@/framework/Http/Http";

const http = new Http();
class Service {
  getFileInfoByPath = async url => {
    const BASE_URL = process.env.BASE_URL;
    const res = await http.getFileBlob(BASE_URL + url);
    const fileName = UtilFile.getFileNameFromPath(url);
    const filetype = UtilFile.getFileTypeByName(fileName);
    const fileBlob = res.data;
    return { fileName, filetype, fileBlob };
  };
}

export default Service;
